__turbopack_context__.v({
  "icon": "SidebarNav-Item-module-scss-module__gniFIW__icon",
  "item": "SidebarNav-Item-module-scss-module__gniFIW__item",
  "leftSection": "SidebarNav-Item-module-scss-module__gniFIW__leftSection",
  "rightSection": "SidebarNav-Item-module-scss-module__gniFIW__rightSection",
  "text": "SidebarNav-Item-module-scss-module__gniFIW__text",
});
